<template>
  <textarea @input="updateValue($event.target.value)">{{value}}</textarea>
</template>

<script>
  import autosize from 'autosize'

  export default {
    props: ['value'],
    methods: {
      updateValue(value) {
        this.$emit('input', value)
      }
    },
    mounted() {
      autosize(this.$el)
    }
  }
</script>



// WEBPACK FOOTER //
// app/javascript/components/autosize-textarea.vue?0b01ab07